import useCourseCompareStore from './store';
import { CourseCompareState, Course } from '../courseCompare/types';

const useCourseCompare = (): {
    store: CourseCompareState;
    addCourse: (course: Course) => void;
    removeCourse: (course: Course) => void;
    clearCourses: () => void;
} => {
    const store = useCourseCompareStore(state => state);
    const addCourse = useCourseCompareStore(state => state.addCourse);
    const removeCourse = useCourseCompareStore(state => state.removeCourse);
    const clearCourses = useCourseCompareStore(state => state.clearCourses);

    return { store, addCourse, removeCourse, clearCourses };
};

export default useCourseCompare;
